import { call } from '../core'

export interface IFinGetLineInfo {
  accessToken: string
  lineUserId: string
}

export const EmptyLineInfo: IFinGetLineInfo = {
  accessToken: '',
  lineUserId: '',
}

export interface IFinGetLineInfoResult {
  result: IFinGetLineInfo | null
}

export function finGetLineInfo(): Promise<IFinGetLineInfoResult | Error> {
  return call('finGetLineInfo')
}
